(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanyBankAccountInfoControllerV3', CompanyBankAccountInfoControllerV3);

    CompanyBankAccountInfoControllerV3.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'BankAccountInfo', 'BankAccountInfoCustom', 'CompanyCustom', '$window', '$http', 'ENV'];

    function CompanyBankAccountInfoControllerV3($rootScope, $state, $timeout, $scope, $stateParams, BankAccountInfo, BankAccountInfoCustom, CompanyCustom, $window, $http, ENV) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.onlinePaymentGatewayType = '';
        vm.currentCompany = {};
        vm.onGatewayChange = onGatewayChange;


        vm.okModal = okModal;
        vm.closeModal = closeModal;

        $rootScope.$broadcast('hideNavBar');

        // loadData();

        // function loadData() {
        //     vm.bankAccountInfo = BankAccountInfoCustom.findBankAccountInfoByCurrentCompnay().query();
        //     findCurrentCompany();
        // }

        // function findCurrentCompany() {
        //     CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
        //         vm.currentCompany = result;
        //     });
        // }


        function save() {
            vm.isSaving = true;
            if (vm.bankAccountInfo.id !== null) {
                BankAccountInfo.update(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            } else {
                BankAccountInfo.save(vm.bankAccountInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:bankAccountInfoUpdate', result);
            //$uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function okModal() {
            save();
        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.setting');
        }

        vm.goToRequestForm = function goToRequestForm() {
            $window.open('https://podform.ir/f/cEaNaE3l95Oby3pTVYF-dA==', '_blank');
        }

        function onGatewayChange() {
            if (vm.bankAccountInfo.gateway && (vm.bankAccountInfo.gateway == 'SUPPLIER_AP' || vm.bankAccountInfo.gateway == 'SUPPLIER_SEP')
                && !vm.bankAccountInfo.gatewaySettingObject
            ) {
                vm.bankAccountInfo.gatewaySettingObject = {};
            }
        }

        function loadKyc() {
            var kyc = document.getElementById('kyc');
            kyc.addEventListener('backEvent', function(e){
                closeModal()
            })

        }
        $timeout(loadKyc, 50)

    }
})();
